import AuthService from "../services/auth.service";
import Cookies from "js-cookie";
//import jwt_decode from "jwt-decode";

const user = Cookies.get('user');
//const vuex = JSON.parse(localStorage.getItem("vuex"));
// let user = "";
// if (vuex != null) {
//   user = vuex.auth.user;
// }
//console.log(jwt_decode(user.accessToken));
const initialState = user
  ? { status: { loggedIn: true }, user, access: null }
  : { status: { loggedIn: false }, user: null, access: null };

export const auth = {
  namespaced: true,
  state: initialState,
  actions: {
    login({ commit }, user) {
      return AuthService.login(user).then(
        user => {
          commit("loginSuccess", user);
          return Promise.resolve(user);
        },
        error => {
          commit("loginFailure");
          return Promise.reject(error);
        }
      );
    },
    logout({ commit }) {
      AuthService.logout();
      commit("logout");
    },
    register({ commit }, user) {
      return AuthService.register(user).then(
        response => {
          commit("registerSuccess");
          return Promise.resolve(response.data);
        },
        error => {
          commit("registerFailure");
          return Promise.reject(error);
        }
      );
    },
    resetPassword(_, payload) {
      return AuthService.resetPassword(payload).then(
        response => {
          //commit("ResetPassword", response.data);
          //console.log(response.data);
          return Promise.resolve(response.data);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    changePassword(_, payload) {
      return AuthService.changePassword(payload).then(
        response => {
          //commit("ResetPassword", response.data);
          ///console.log(response.data);
          return Promise.resolve(response.data);
        },
        error => {
          return Promise.reject(error);
        }
      );
    },
    decode({ commit }) {
      const jwt = AuthService.jwtDecode();
      commit("decode", jwt);
    },
    active(_, payload) {
      return AuthService.active(payload).then(
        response => {
          //commit("ResetPassword", response.data);
          ///console.log(response.data);
          return Promise.resolve(response.data);
        },
        error => {
          return Promise.reject(error);
        }
      );
    }
  },
  mutations: {
    loginSuccess(state, user) {
      state.status.loggedIn = true;
      state.user = user;
      //state.access = jwt_decode(user.accessToken);
    },
    loginFailure(state) {
      state.status.loggedIn = false;
      state.user = null;
      state.access = null;
    },
    logout(state) {
      state.status.loggedIn = false;
      state.user = null;
      //state.access = null;
      //state.stations = null;
    },
    registerSuccess(state) {
      state.status.loggedIn = false;
      //state.users.unshift(user);
    },
    registerFailure(state) {
      state.status.loggedIn = false;
    },
    decode(state, payload) {
      state.access = payload;
    }
  }
};
